module.exports = __webpack_public_path__ + "static/media/S3N12-5.c1d567b3.svg";